<template>
  <q-item
    :id="setDrawerId(title)"
    v-ripple
    clickable
    tag="a"
    :to="to"
    :data-active-menu="trimmedText"
    :class="isChild ? 'is-child' : ''"
  >
    <q-item-section
      avatar
      class="items-center"
    >
      <q-avatar
        v-if="icon"
        square
      >
        <q-img
          data:src="icon"
          :src="require('src/assets/images/icons/' + icon)"
          :alt="title"
          spinner-color="primary"
          style="height: 20px; max-width: 20px"
        />
      </q-avatar>
    </q-item-section>

    <q-item-section>
      <q-item-label text-color="grey-6">
        {{ title }}
      </q-item-label>
    </q-item-section>
    <!--
    // * Pengajuan Badge SKU
    -->
    <q-item-section
      v-if="title === 'Pengajuan SKU'"
      side
    >
      <div v-if="badge">
        <q-badge
          rounded
          color="negative"
          :label="badge"
        />
      </div>
    </q-item-section>
  </q-item>
</template>

<script>
import { textToCamelCase } from 'src/helpers'

export default {
  name: 'EssentialLink',
  props: {
    title: {
      type: String,
      required: true
    },

    to: {
      type: String,
      default: '#'
    },

    icon: {
      type: [String, Boolean],
      default: ''
    },

    activeMenu: {
      type: String,
      default: null
    },

    isChild: {
      type: Boolean,
      default: false
    },

    badge: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      // minusIcon: require('src/assets/images/icons/minus-small.svg')
    }
  },

  computed: {
    trimmedText () {
      return this.activeMenu.replace(/\s/g, '').toLowerCase()
    }
  },

  methods: {
    setDrawerId (val) {
      return textToCamelCase(val)
    }
  }
}
</script>
